import React, { useEffect } from "react";
import "./About1.css";
import aboutimg from "../images/computer.jpg";

const About1 = () => {
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("in-view");
          }
        });
      },
      { threshold: 0.1 }
    );

    const elements = document.querySelectorAll(".about1 .animate-side");
    elements.forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  return (
    <div className="about1" id="about1">
      <div className="content">
        <div className="content1">
          <h1 className="about-title animate-side slide-left row-0">
            About Us
          </h1>

          <p className="animate-side slide-right row-1">
            At Dataharbor, we empower businesses, retailers, and restaurants 
            with smart, end-to-end software and design solutions. Whether you 
            need a sleek custom web or mobile application, an intuitive Cloud 
            POS and ERP system to streamline operations, an online store, or 
            digital menu solutions for your venue, we transform complex systems 
            into seamless digital experiences.
          </p>
        </div>

        <div className="image animate-side slide-left row-2">
          <img className="imgs" src={aboutimg} alt="ERP System Computer Interface" />
        </div>
      </div>
    </div>
  );
};

export default About1;